/** Font Awesome 5 solid icon names (must exist in bundled FA ~5.0.10). */
export function casinoCategoryIconClass(categoryId: string): string {
  const s = (categoryId || '').toLowerCase().replace(/\s+/g, '')
  if (s.includes('slot')) return 'fa-cube'
  if (s.includes('roulette')) return 'fa-circle-notch'
  if (s.includes('baccarat')) return 'fa-gem'
  if (s.includes('poker') || s.includes('teen')) return 'fa-clone'
  if (s.includes('andar')) return 'fa-heart'
  if (s.includes('dragon') || s.includes('tiger')) return 'fa-fire'
  if (s.includes('crash')) return 'fa-chart-line'
  if (s.includes('fish')) return 'fa-tint'
  if (s.includes('arcade')) return 'fa-gamepad'
  if (s.includes('card')) return 'fa-clone'
  if (s.includes('dice')) return 'fa-cube'
  if (s.includes('lottery') || s.includes('instant')) return 'fa-ticket-alt'
  if (s.includes('india')) return 'fa-flag'
  if (s.includes('gamble')) return 'fa-money-bill-alt'
  if (s.includes('casinolive') || s.includes('live')) return 'fa-video'
  if (s.includes('table')) return 'fa-table'
  if (s.includes('classic')) return 'fa-chess'
  if (s.includes('casual')) return 'fa-smile'
  if (s.includes('mini')) return 'fa-compress'
  if (s.includes('aviator') || s.includes('plane')) return 'fa-plane'
  if (s.includes('monopoly')) return 'fa-building'
  if (s.includes('lucky') || s.includes('7')) return 'fa-star'
  return 'fa-th-large'
}
